import { DOMAIN } from './Disclosures.constants';
import get from 'lodash/get';

export const getStore = state => get(state, DOMAIN) || [];

export const getResults = state => getStore(state);
export const getResultCount = state => getStore(state).length;
